import { FunctionComponent } from 'react';
import { t } from '@/utils/i18n';
import { ProductTypeSwitchProps } from '@/redux/modal/types';
import { ModalProps } from '@/components/common/ModalManager';
import { SwitchDialog } from '@/components/common/SwitchDialog';

export const ProductTypeSwitchDialog: FunctionComponent<ProductTypeSwitchProps & ModalProps> = ({
  cids,
  reason,
  accept,
  dismiss,
}) => {
  return (
    <SwitchDialog
      cids={cids}
      title={t(`productTypeSelector.dialog.${reason}.title`)}
      hint={t(`productTypeSelector.dialog.${reason}.hint`)}
      acceptText={t(`productTypeSelector.dialog.apply`)}
      cancelText={t(`productTypeSelector.dialog.cancel`)}
      onAccept={accept}
      onCancel={dismiss}
    />
  );
};
